/* eslint-disable react/no-danger */
/* eslint-disable jsx-a11y/alt-text */
import React, { Component } from 'react';
import { getResponsiveImage } from '@/componentWebs/NbmImageNew';
import { connect } from 'react-redux';
import { Slider, DatePicker, Spin } from 'antd';
import { formatNumber } from '@/utils/utils';
import EncodeUrl from '@/utils/encode';
import Cascaderprovinces from '@/componentWebs/Common/Cascaderprovinces';
import Pagination from '@/componentWebs/Pagination';
import FilterCategory from '@/componentWebs/Common/FilterCategory';
import TourDiemDenSelect from '@/componentWebs/Common/TourDiemDenSelect';

// import 'moment/locale/vi_VN';
// import locale from 'antd/';

import moment from 'moment';

moment.locale('vi');

const pageSize = 8;
const { RangePicker } = DatePicker;

@connect(({ webs: { dataAd } }) => ({
  dataAd,
}))
class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fromValue: null,
      toValue: null,
      dataIntroduse: [],
      activeTabs: '',
      pagi: {},
      hideNav: null,
      diemXuatPhat: [],
      diemDen: props.travelTourDestinationLocations || [],
      // date: props.travelTourPackageDepart || [moment(), moment()],
      date: props.travelTourPackageDepart || [moment(), moment().add(30, 'days')],
      range: [0, pageSize - 1],
      isInternational: props.isInternational || '',
      diemDenText: props.diemDenText || '',
      type: '',
      isInternational: props.isInternational || '0',
      textProvinces: props.textProvinces || '',
      loading: true,
      key: Math.random(),
    };
  }

  componentWillReceiveProps(nextProps) {
    const { isInternational, textProvinces } = this.props;
    if (isInternational !== nextProps.isInternational) {
      this.setState({
        isInternational: nextProps.isInternational,
      });
    }
    if (textProvinces !== nextProps.textProvinces) {
      this.setState({
        textProvinces: nextProps.textProvinces,
      });
    }
  }

  componentDidMount() {
    this.fetch();

    window.addEventListener('resize', this.resize.bind(this), { passive: true });
    this.resize();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resize.bind(this));
  }

  resize() {
    this.setState({ hideNav: window.innerWidth < 1024 });
  }

  fetch = () => {
    const { dispatch } = this.props;
    const {
      activeTabs,
      fromValue,
      toValue,
      diemXuatPhat,
      diemDen,
      date,
      range,
      isInternational,
    } = this.state;

    const tfilter = {
      status: '1',
      travelVisaPackagesStatus: '1',
      travelTourIsCombo: true,
      travelTourPackageDealPrice: [fromValue, toValue],
      travelTourOriginLocations: {
        countries: [diemXuatPhat[0] && Number(diemXuatPhat[0])],
        provinces: [diemXuatPhat[1] && Number([diemXuatPhat[1]])],
      },
      travelTourDestinationLocations: {
        countries: [diemDen[0] && Number([diemDen[0]])],
        provinces: [diemDen[1] && Number(diemDen[1])],
        isInternational,
      },
      travelTourPackageDepart: [
        moment(date[0], 'DD/MM/YYYY').format('YYYY-MM-DD'),
        moment(date[1], 'DD/MM/YYYY').format('YYYY-MM-DD'),
      ],
    };

    if (!isInternational) delete tfilter.travelTourDestinationLocations.isInternational;
    if ((!fromValue && fromValue !== 0) || (!toValue && toValue !== 0))
      delete tfilter.travelTourPackageDealPrice;

    // Điểm xp
    if (!diemXuatPhat || (diemXuatPhat && diemXuatPhat.length === 0)) {
      delete tfilter.travelTourOriginLocations;
    }
    if (diemXuatPhat && diemXuatPhat.length > 0) {
      if (!diemXuatPhat[0]) delete tfilter.travelTourOriginLocations.countries;
      if (!diemXuatPhat[1]) delete tfilter.travelTourOriginLocations.provinces;
    }

    // Điểm điểm
    if (!diemDen || (diemDen && diemDen.length === 0)) {
      delete tfilter.travelTourDestinationLocations;
    }
    if (diemDen && diemDen.length > 0) {
      if (!diemDen[0]) delete tfilter.travelTourDestinationLocations.countries;
      if (!diemDen[1]) delete tfilter.travelTourDestinationLocations.provinces;
    }

    let sort = [];

    switch (activeTabs) {
      case '1': {
        sort = ['travelTourPackageDealPrice', 'ASC'];
        break;
      }
      case '2': {
        sort = ['travelTourPackageDealPrice', 'DESC'];
        break;
      }
      case '3': {
        sort = ['percentDealPrice', 'asc'];
        break;
      }

      default:
        break;
    }

    const queryString = {
      filter: tfilter,
      range,
      sort,
    };

    if (queryString.sort.length === 0) delete queryString.sort;
    this.setState({
      loading: true,
    });
    dispatch({
      type: 'webs/fetchComboTour',
      payload: queryString,
      callback: res => {
        if (res.success) {
          if (res.result && res.result.list) {
            const dataIntroduse = res.result.list || [];
            this.setState({
              dataIntroduse,
              pagi: (res && res.result && res.result.pagination) || {},
              loading: false,
            });
          }
        }
      },
    });
  };

  filterPrice = tab => {
    this.setState(
      {
        activeTabs: tab,
      },
      () => {
        this.fetch();
      }
    );
  };

  onAfterChange = value => {
    this.setState(
      {
        fromValue: value[0],
        toValue: value[1],
      },
      () => {
        this.fetch();
      }
    );
  };

  handleChangePagi = currentPagesss => {
    const indexOfLastNews = currentPagesss * pageSize; // vị trí của tin cuối cùng trong list được hiển thị
    const indexOfFirstNews = indexOfLastNews - pageSize;

    this.setState(
      {
        range: [indexOfFirstNews, indexOfLastNews - 1],
      },
      () => {
        this.fetch();
      }
    );
  };

  handleDetail = item => {
    window.location.href = `/combo/${EncodeUrl(item.travelTourName)}/${item.id}`;
  };

  handleChaneProvince = (value, countries, type) => {
    // console.log('value: ', value);
    this.setState(
      {
        [type]: value ? [countries, value] : [],
      },
      () => {
        this.fetch();
      }
    );
  };

  handleDate = value => {
    this.setState(
      {
        date: value,
      },
      () => {
        this.fetch();
      }
    );
  };

  handleClear = () => {
    const { visible } = this.state;
    const { isSearch } = this.props;
    // console.log("isSearch: ", isSearch);

    if (isSearch) {
      this.setState(
        {
          fromValue: null,
          toValue: null,
          diemXuatPhat: [],
          // diemDen: [],
          // date: [moment(), moment().add(30, 'days')],
          activeTabs: '',
          range: [0, pageSize - 1],
          visible: !visible,
          key: Math.random(),
        },
        () => this.fetch()
      );
    } else {
      this.setState(
        {
          fromValue: null,
          toValue: null,
          diemXuatPhat: [],
          diemDen: [],
          date: [moment(), moment().add(30, 'days')],
          activeTabs: '',
          range: [0, pageSize - 1],
          visible: !visible,
          textProvinces: '',
          key: Math.random(),
        },
        () => this.fetch()
      );
    }
  };

  render() {
    // const { data } = this.props;
    const {
      fromValue,
      toValue,
      pagi,
      date,
      dataIntroduse,
      diemXuatPhat,
      diemDen,
      diemDenText,
      activeTabs,
      type,
      visible,
      hideNav,
      isInternational,
      textProvinces,
      loading,
      key,
    } = this.state;

    const { searchType, imageResize, typeTab } = this.props;
    // console.log("textProvinces: ", textProvinces, diemDen[1]);

    const boloc = (
      <div className="datVeMayBay__filter-box">
        <div className="datVeMayBay__filter-box__header flex-b-c">
          <div className="title" onClick={() => this.setState({ visible: !visible })}>
            Bộ lọc
          </div>
          <div className="clear" onClick={this.handleClear} style={{ cursor: 'pointer' }}>
            Xóa lọc
          </div>
        </div>
        <div className="datVeMayBay__filter-box__main">
          {/* Một ô filter  */}
          <div className="datVeMayBay__filter-box__rectangle">
            <div className="datVeMayBay__filter-box__title">Khoảng giá</div>
            <div className="wrapper_silder-title">
              <p className="slider-title flex-b-c">
                <span id="min">{fromValue ? formatNumber(fromValue * 1) : 0}₫</span>
                <span id="max">
                  {toValue ? formatNumber(toValue ? toValue * 1 : 50000000) : 50000000}₫
                </span>
              </p>
              <Slider
                className="slider-track-custom"
                range
                step={100000}
                defaultValue={[0, 50000000]}
                value={[fromValue || 0, toValue || 50000000]}
                min={0}
                max={50000000}
                tooltipVisible={false}
                onChange={value =>
                  this.setState({
                    fromValue: value[0],
                    toValue: value[1],
                  })
                }
                onAfterChange={this.onAfterChange}
              />
            </div>
          </div>
          {/* Một ô filter  */}
          <div className="datVeMayBay__filter-box__rectangle">
            <div className="datVeMayBay__filter-box__title">Ngày khởi hành</div>

            <div className="wrapper_silder-title">
              <RangePicker
                allowClear={false}
                style={{ width: '100%' }}
                format="DD/MM/YYYY"
                disabledDate={val => val < moment().subtract(1, 'days')}
                onChange={this.handleDate}
                value={date}
                placeholder={['Chọn ngày bắt đầu', 'Chọn ngày kết thúc']}
              />
            </div>
          </div>
          {/* Một ô filter  */}
          <div className="datVeMayBay__filter-box__rectangle">
            <div className="datVeMayBay__filter-box__title">Điểm xuất phát</div>
            <div className="wrapper_silder-title">
              {/* <Cascaderprovinces
                onChange={value => this.handleChaneProvince(value, 'diemXuatPhat')}
                value={diemXuatPhat}
                allowClear
                placeholder="Chọn điểm xuất phát"
              /> */}
              <TourDiemDenSelect
                value={diemXuatPhat[1] && Number.isInteger(diemXuatPhat[1]) && `${diemXuatPhat[1]}` || diemXuatPhat[1] || undefined}
                isInternational={isInternational}
                key={`from_${key}`}
                placeholder="Chọn điểm xuất phát"
                filter
                onChange={(value, countries) =>
                  this.handleChaneProvince(value, countries, 'diemXuatPhat')
                }
              />
            </div>
          </div>
          {/* Một ô filter  */}
          <div className="datVeMayBay__filter-box__rectangle">
            <div className="datVeMayBay__filter-box__title">Điểm đến</div>
            <div className="wrapper_silder-title">
              <TourDiemDenSelect
                value={diemDen[1] && Number.isInteger(diemDen[1]) && `${diemDen[1]}` || diemDen[1] || undefined}
                placeholder="Chọn điểm đến"
                key={`to_${key}`}
                isInternational={isInternational}
                text={textProvinces}
                disabled={typeTab}
                filter
                onChange={(value, countries) =>
                  this.handleChaneProvince(value, countries, 'diemDen')
                }
              />
              {/* <Cascaderprovinces
                onChange={value => this.handleChaneProvince(value, 'diemDen')}
                value={diemDen}
                allowClear
                placeholder="Chọn điểm đến"
              /> */}
            </div>
          </div>

          <div className="datVeMayBay__filter-box__rectangle hidden-pc">
            <button
              className="btn box-product__btn btnapdung "
              type="button"
              onClick={() => this.setState({ visible: !visible })}
            >
              <span>Áp dụng</span>
            </button>
          </div>
        </div>
      </div>
    );

    const sort = (
      <ul className="datVeMayBay__right-filter__list flex-a-c sortMobile">
        <li className={activeTabs === '3' && 'active'}>
          <span onClick={() => this.filterPrice('3')}>Giảm giá sâu</span>
          <i className="fas fa-times" onClick={() => this.filterPrice('')} />
        </li>
        <li className={activeTabs === '1' && 'active'}>
          <span onClick={() => this.filterPrice('1')}>Giá thấp nhất</span>
          <i className="fas fa-times" onClick={() => this.filterPrice('')} />
        </li>
        <li className={activeTabs === '2' && 'active'}>
          <span onClick={() => this.filterPrice('2')}>Giá giảm dần</span>
          <i className="fas fa-times" onClick={() => this.filterPrice('')} />
        </li>
      </ul>
    );

    // const template =
    //   data.templateLayouts && data.templateLayouts.templates && data.templateLayouts.templates[0];
    // const imageResize =
    //   template && template.templateLayoutTemplates && template.templateLayoutTemplates.imagesResize;

    return (
      // Tin tức trang chủ
      <React.Fragment>
        {searchType && (
          <div className="khachSan__search-result hidden-m-t flex-a-c">
            <div className="name">{diemDenText ? `Combo du lịch tại ${diemDenText}: ` : `Có:`}</div>
            <div className="result">
              ({pagi && pagi.total}) <span>combo du lịch</span>
            </div>
          </div>
        )}

        <div className="khachSan-products tour-product">
          <div className="row row-padding boloc hidden-pc visa-boloc">
            <div
              className="itemBoloc"
              onClick={() => {
                this.setState({ visible: !visible, type: '1' });
              }}
            >
              <img
                src="/static/vietnamTickets/images/Icon feather-filter.svg"
                alt=""
                className="lazyload"
              />
              Bộ lọc
            </div>
            <div
              className="itemBoloc"
              onClick={() => {
                this.setState({ visible: !visible, type: '2' });
              }}
            >
              <img
                src="/static/vietnamTickets/images/Icon awesome-sort-amount-down.svg"
                alt=""
                className="lazyload"
              />
              Sắp xếp
            </div>
          </div>
          <div className="row row-padding">
            <div className="col-lg-3 hidden-m-t">{boloc}</div>
            <div className="col-lg-9 col-padding">
              <div className="khachSan-products__wrapper">
                {/* O filter  */}
                <div className="datVeMayBay__right-filter khachSan__right-filter flex-b-c hidden-m-t">
                  {sort}
                </div>
                {/* lisst  */}
                <Spin spinning={loading}>
                  {dataIntroduse && dataIntroduse.length > 0 ? (
                    <ul className="khachSan-products__list">
                      {dataIntroduse.map(item => (
                        <li className="khachSan-products__item flex-a-c" key={item.id}>
                          <div className="row row-padding">
                            <div className="col-lg-4 col-padding">
                              <div
                                className="khachSan-products__img"
                                onClick={() => this.handleDetail(item)}
                              >
                                <img
                                  src={getResponsiveImage(
                                    item.travelTourImage &&
                                    item.travelTourImage[0] &&
                                    item.travelTourImage[0].file, imageResize
                                  )}
                                  alt={item.travelTourName}
                                  className="lazyload"
                                />
                              </div>
                            </div>
                            <div className="col-lg-8 col-padding">
                              <div className="khachSan-products__detail">
                                <div
                                  className="khachSan-products__title"
                                  onClick={() => this.handleDetail(item)}
                                >
                                  {item.travelTourName}
                                </div>
                                <div className="khachSan-products__info flex-b-c">
                                  <ul className="tour_info tour_info__component">
                                    <li>
                                      <i className="fas fa-map-marker-alt" />
                                      <div className="text">
                                        Xuất phát:{' '}
                                        {`${item.travelTourOriginProvinces &&
                                          item.travelTourOriginProvinces
                                            .provinceName} - ${item.travelTourOriginProvinces &&
                                            item.travelTourOriginProvinces.countries &&
                                            item.travelTourOriginProvinces.countries.countrieName}`}
                                      </div>
                                    </li>
                                    <li>
                                      <i className="fas fa-calendar-week" />
                                      <div className="text">
                                        Khởi hành:{' '}
                                        {moment(item.travelTourPackageDepart).format('DD/MM/YYYY')}
                                      </div>
                                    </li>
                                    <li>
                                      <i className="far fa-clock" />
                                      <div className="text">Thời gian: {item.travelTourTime}</div>
                                    </li>
                                    <li>
                                      <i className="fas fa-route" />
                                      <div className="text">
                                        Phương tiện di chuyển: {item.travelTourTransport}
                                      </div>
                                    </li>
                                  </ul>
                                  <div className="khachSan-products__prices">
                                    <div className="products__prices">
                                      {item.percentDealPrice &&
                                        Number(item.percentDealPrice) !== 0 && (
                                          <div className="prices">
                                            {formatNumber(item.travelTourPackagePrice)}đ / đêm
                                          </div>
                                        )}

                                      <div className="dealPrices">
                                        {formatNumber(item.travelTourPackageDealPrice)}đ /{' '}
                                        <span> đêm</span>
                                      </div>
                                    </div>
                                    <button
                                      className="btn box-product__btn flex-a-c"
                                      type="button"
                                      onClick={() => this.handleDetail(item)}
                                    >
                                      <span>Đặt ngay</span>
                                      <i className="fas fa-long-arrow-alt-right" />
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          {item.percentDealPrice && Number(item.percentDealPrice) !== 0 && (
                            <div className="salesOff"> -{item.percentDealPrice || 0}%</div>
                          )}
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <>
                      {searchType ? (
                        <div className="no-result">
                          {loading ? '' : 'Không tìm thấy combo phù hợp'}
                        </div>
                      ) : (
                        ''
                      )}
                    </>
                    // <h2
                    //   style={{ width: '100%', textAlign: 'center', fontSize: 20, marginTop: '20px' }}
                    // >
                    //   Không tìm thấy combo phù hợp
                    // </h2>
                  )}
                </Spin>

                {pagi.total > pageSize - 1 && (
                  <Pagination
                    style={{ textAlign: 'right', marginTop: '20px' }}
                    onChange={this.handleChangePagi}
                    current={pagi && pagi.current}
                    total={pagi && pagi.total}
                    pageSize={pageSize}
                  />
                )}

                {/* {dataIntroduse && dataIntroduse.length === 20 && (
                  <Pagination
                    style={{ textAlign: 'right', marginTop: '20px' }}
                    onChange={this.handleChangePagi}
                    current={pagi && pagi.current}
                    total={pagi && pagi.total}
                    pageSize={pageSize}
                  />
                )} */}
              </div>
            </div>
          </div>
        </div>

        {hideNav && (
          <FilterCategory visibleDrawer={visible} type={type}>
            {type === '1' && boloc}
            {type === '2' && sort}
          </FilterCategory>
        )}
      </React.Fragment>
    );
  }
}

export default Index;
